import React, { useState, useEffect, useCallback, useRef, useMemo } from 'react';
import { useRota } from '../../Contexts/RotaContext';
import TradutorMapa from '../Vendas/TradutorMapa';
import loadingGif from '../../assets/gifs/loading.gif';
import BannerExpositores from '../../Components/Common/BannerRotaMapa';
import MapaFeiraBasico from "./Mapa";
import ModalFiltros from '../../Components/Common/ModalFiltroRota';
import EncontrarRotaPanel from './ModalRota';
import { generateDirections, findShortestPathWithContext } from '../../funcoes/roteamento';
import { Input, Modal, ModalHeader, ModalBody, Row, Col, FormGroup, Label } from 'reactstrap';
 import { toast } from 'react-toastify';
import { QRCodeSVG } from 'qrcode.react';
import { useSearchParams } from 'react-router-dom';
import { FooterDev } from './components/FooterDev';
import Select from 'react-select';
import '../../assets/scss/rotas/rotas.scss';
import { trackEvent } from "../../analytics";
import CommercialModal from "../../Components/Common/ModalContatoComercial";

const padTo2Digits = (num) => num.toString().padStart(2, '0');

const formatarPeriodoEvento = (dataInicioStr, dataFimStr) => {
  try {
      if (!dataInicioStr || !dataFimStr) return "";

      const dataInicio = new Date(dataInicioStr);
      const dataFim = new Date(dataFimStr);
      const diaInicio = padTo2Digits(dataInicio.getUTCDate());
      const mesInicio = padTo2Digits(dataInicio.getUTCMonth() + 1);
      const anoInicio = dataInicio.getUTCFullYear().toString().slice(-2);

      const diaFim = padTo2Digits(dataFim.getUTCDate());
      const mesFim = padTo2Digits(dataFim.getUTCMonth() + 1);
      const anoFim = dataFim.getUTCFullYear().toString().slice(-2);

      return `${diaInicio}/${mesInicio}/${anoInicio} a ${diaFim}/${mesFim}/${anoFim}`;
  } catch (error) {
      console.error("Erro ao formatar datas:", error);
      return "";
  }
};

const ExpositorCardMemo = React.memo(({ exhibitor, onCardClick, onTraceRouteClick }) => {
  const [imageError, setImageError] = useState(false);

  const displayName = exhibitor.nome_mapa || exhibitor.nome || 'Expositor';

  const initials = useMemo(() => {
    return displayName
      .split(' ')
      .map(n => n[0])
      .slice(0, 2)
      .join('')
      .toUpperCase();
  }, [displayName]);

  return (
    <div className="featured-card exhibitor-card-container">
      <button 
        type="button"
        className="card-main-action"
        onClick={() => onCardClick(exhibitor)}
        title={`Selecionar ${displayName} no mapa`}
      >
        <div className="d-flex align-items-center w-100">
          <div className="flex-shrink-0 exhibitor-logo-wrapper">
            {exhibitor.logoUrl && !imageError ? (
              <img 
                src={exhibitor.logoUrl} 
                loading="lazy"
                decoding="async"
                alt={`Logo ${displayName}`} 
                className="avatar-sm rounded-circle exhibitor-logo"
                onError={() => setImageError(true)} // Se falhar, muda o estado
              />
            ) : (
              <div className="avatar-sm rounded-circle exhibitor-logo-fallback">
                {initials}
              </div>
            )}
          </div>

          <div className="flex-grow-1 ms-3 text-start exhibitor-name-wrapper">
            <h5 className="mb-0 exhibitor-name" title={displayName}>
              {displayName}
            </h5>
          </div>
        </div>
      </button>

      <button
        type="button"
        className="btn-trace-route-direct"
        onClick={(e) => {
          e.stopPropagation(); 
          onTraceRouteClick(exhibitor);
        }}
        title={`Traçar rota até ${displayName}`}
      >
        <i className="ri-map-pin-user-line"></i> 
      </button>
    </div>
  );
});

function RouteTopBarMobile({
  origemId,
  destinoId,
  destinosOptions = [],
  getOptionByValue,
  onOrigemChange,
  onDestinoChange,
  onInverter,
  onCalcularRota,
  onFecharRota,
}) {
  const portalTarget = typeof document !== "undefined" ? document.body : null;

  const selectStyles = {
    menuPortal: (base) => ({ ...base, zIndex: 9999999999 }),
    menu: (base) => ({ ...base, zIndex: 9999999999 }),
  };

  const selectedOrigem = getOptionByValue ? getOptionByValue(origemId) : null;
  const selectedDestino = getOptionByValue ? getOptionByValue(destinoId) : null;

  const canTrace = !!origemId && !!destinoId;

  return (
    <div className="route-topbar" role="region" aria-label="Encontrar rota">
      <button
        className="route-topbar__close"
        onClick={onFecharRota}
        aria-label="Fechar"
        type="button"
      >
        <span aria-hidden>✕</span>
      </button>

      <div className="route-topbar__grid">
        <div className="route-topbar__fields">
          <div className="route-topbar__field">
            <Select
              classNamePrefix="react-select"
              value={selectedOrigem}
              onChange={onOrigemChange}
              options={destinosOptions}
              placeholder="Selecione um ponto de partida..."
              isClearable
              isSearchable
              menuPortalTarget={portalTarget}
              menuPosition="fixed"
              menuPlacement="auto"
              menuShouldScrollIntoView={false}
              maxMenuHeight={280}
              styles={selectStyles}
            />
          </div>

          <div className="route-topbar__field">
            <Select
              classNamePrefix="react-select"
              value={selectedDestino}
              onChange={onDestinoChange}
              options={destinosOptions}
              placeholder="Selecione um destino..."
              isClearable
              isSearchable
              menuPortalTarget={portalTarget}
              menuPosition="fixed"
              menuPlacement="auto"
              menuShouldScrollIntoView={false}
              maxMenuHeight={280}
              styles={selectStyles}
            />
          </div>
        </div>

        {/* COLUNA DIREITA: BOTÃO INVERTER (centralizado entre os dois) */}
        <div className="route-topbar__side">
          <button
            type="button"
            className="route-topbar__swap"
            onClick={onInverter}
            disabled={!origemId && !destinoId}
            aria-label="Inverter origem e destino"
            title="Inverter origem e destino"
          >
            ⇅
          </button>
        </div>
      </div>

      <div className="route-topbar__actions">
        <button
          type="button"
          className="route-topbar__btn route-topbar__btn--primary"
          onClick={onCalcularRota}
          disabled={!canTrace}
        >
          Traçar rota
        </button>
      </div>
    </div>
  );
}

const RotasModulo = () => {
    document.title = "Evomap - Tecnologia que conecta negócios - Rotas";

    const searchTimerRef = useRef(null);
    const [isFilterModalOpen, setFilterModalOpen] = useState(false);
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const [activeTab, setActiveTab] = useState('expositores');
    const [isRoutePanelOpen, setIsRoutePanelOpen] = useState(false);
    const [exibirInstrucoesMobile, setExibirInstrucoesMobile] = useState(true);
    const isPanelOpen = isRoutePanelOpen;
    const setIsPanelOpen = setIsRoutePanelOpen;

    const {
        feira,
        isLoading,
        error,
        clearSelectedExpositor,
        estandesCadastrados,
        areasInteresseFeira,
        categoriasFeira, 
        setoresFeira,
        mapData,
        fundoUrl,
        imagemFundo,
        tiposEspacoFeira,
        nodes, 
        edges,
        tilesUrl,
        expositores,
        regras,
    } = useRota();

    const periodoFormatado = useMemo(() => {
      if (feira?.data_inicio && feira?.data_fim) {
          return formatarPeriodoEvento(feira.data_inicio, feira.data_fim);
      }
      return ""; 
    }, [feira]);

    const EMPTY_ARRAY = [];
    const destacarEstandeRef = useRef(null);
    const mapRef = useRef(null);

    const [estandeDestacado, setEstandeDestacado] = useState(null);
    const [filtrosAtivos, setFiltrosAtivos] = useState({});
    const [origemId, setOrigemId] = useState('');
    const [destinoId, setDestinoId] = useState('');
    const origemIdRef = useRef('');
    const destinoIdRef = useRef('');
    const [rotaCalculada, setRotaCalculada] = useState(null);
    const [instrucoes, setInstrucoes] = useState([]);
    const [modalCompartilharVisivel, setModalCompartilharVisivel] = useState(false);
    const [searchParams] = useSearchParams();
    const [zoomTrigger, setZoomTrigger] = useState(0);

    const [highlightedNodeId, setHighlightedNodeId] = useState(null);
    const [routeZoomTrigger, setRouteZoomTrigger] = useState(0);
    const [estandeDestacadoOrigem, setEstandeDestacadoOrigem] = useState(null);
    const [estandeDestacadoDestino, setEstandeDestacadoDestino] = useState(null);
    const [isMobileUI, setIsMobileUI] = useState(false);
    const [sheetState, setSheetState] = useState('collapsed');

    const [origemMeta, setOrigemMeta] = useState(null);
    const [destinoMeta, setDestinoMeta] = useState(null);

    const [exibirModalContato, setExibirModalContato] = useState(false);

    useEffect(() => { origemIdRef.current = origemId; }, [origemId]);
    useEffect(() => { destinoIdRef.current = destinoId; }, [destinoId]);

    const normalizeText = (s) =>
      String(s ?? '')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .trim();

    const pickFirst = (...vals) => vals.find(v => String(v ?? '').trim().length > 0) || '';

    const sortByPrimaryLabel = (a, b) => {
      const ap = (a?.primaryLabel || a?.label || '').toString();
      const bp = (b?.primaryLabel || b?.label || '').toString();
      return ap.localeCompare(bp, 'pt-BR', { sensitivity: 'base' });
    };

    const formatOptions = (data) => data.map(item => ({ value: item.id, label: item.nome }));

    const formatOptionsGeneric = (data = []) => {
      return (data || []).map(item => {
        const primary = pickFirst(item?.nome, item?.name, item?.titulo, item?.title, item?.label, `Espaço ${item?.id ?? ''}`);
        const secondary = pickFirst(item?.codigo, item?.numero, item?.sigla, item?.referencia);

        const search = [
          primary, secondary,
          item?.expositor_nome, item?.expositor?.nome_mapa, item?.expositor?.nome, item?.expositor?.nome_fantasia
        ].filter(Boolean).join(' | ');

        return {
          value: item?.id,
          label: primary,
          primaryLabel: primary,
          secondaryLabel: secondary,
          search,
        };
      }).sort(sortByPrimaryLabel);
    };

    const formatOptionsExpositor = (data = []) => {
      return (data || []).map(item => {
        const primary = pickFirst(item?.nome_mapa, item?.nome, item?.nome_fantasia);
        const secondary = pickFirst(
          (primary !== (item?.nome || '') ? item?.nome : ''),
          (primary !== (item?.nome_fantasia || '') ? item?.nome_fantasia : '')
        );

        const search = [
          item?.nome_mapa, item?.nome, item?.nome_fantasia,
          item?.cnpj_codigo_internacional
        ].filter(Boolean).join(' | ');

        return {
          value: item?.id,
          label: primary,
          primaryLabel: primary,
          secondaryLabel: secondary,
          search,
        };
      }).sort(sortByPrimaryLabel);
    };

    const filterOptionBySearch = (option, inputValue) => {
      const q = normalizeText(inputValue);
      if (!q) return true;
      const hay = normalizeText(option?.data?.search || option?.data?.label || '');
      return hay.includes(q);
    };

    const TwoLineOption = ({ primary, secondary, isValue }) => (
      <div style={{ lineHeight: 1.15 }}>
        <div style={{ fontWeight: 600, fontSize: isValue ? 13 : 13 }}>
          {primary}
        </div>
        {secondary ? (
          <div style={{ fontSize: 12, opacity: 0.75, marginTop: 2 }}>
            {secondary}
          </div>
        ) : null}
      </div>
    );

    const formatOptionLabelTwoLines = (opt, { context }) => {
      const primary = opt?.primaryLabel || opt?.label || '';
      const secondary = opt?.secondaryLabel || '';
      return <TwoLineOption primary={primary} secondary={secondary} isValue={context === 'value'} />;
    };

    const ClearIndicatorLimpar = (props) => {
      const { innerProps } = props;
      return (
        <div
          {...innerProps}
          title="Limpar"
          aria-label="Limpar"
          style={{ display: 'flex', alignItems: 'center', gap: 6, padding: '0 8px', cursor: 'pointer', opacity: 0.85 }}
        >
          <span style={{ fontSize: 12, fontWeight: 600 }}>Limpar</span>
          <span style={{ fontSize: 14, lineHeight: 1 }}>✕</span>
        </div>
      );
    };

    const expositoresOptions = useMemo(() => formatOptionsExpositor(expositores || []), [expositores]);
    const estandesOptions = useMemo(() => formatOptionsGeneric(estandesCadastrados || []), [estandesCadastrados]);
    const showExpositores = expositoresOptions.length > 0;
    const showEstandes = estandesOptions.length > 0;

    useEffect(() => {
      const onResize = () => setIsMobileUI(window.innerWidth <= 960);
      onResize();
      window.addEventListener('resize', onResize);
      return () => window.removeEventListener('resize', onResize);
    }, []);

    const toggleSheet = () => {
      setSheetState((s) => {
        if (s === 'collapsed') return 'half';
        if (s === 'half') return 'full';
        return 'collapsed';
      });
    };

    useEffect(() => {
      if (!isMobileUI) return;
      if (isRoutePanelOpen) setSheetState('half');
      else setSheetState('collapsed');
    }, [isRoutePanelOpen, isMobileUI]);

    const tiposEspacoMap = useMemo(() => {
      const map = new Map();

      (tiposEspacoFeira || []).forEach((t) => {
        const id = Number(t?.tipo_espaco_id ?? t?.id);
        if (Number.isFinite(id)) map.set(id, t);
      });
      
      return map;
    }, [tiposEspacoFeira]);
    
    const GROUP_PREFIX = 'group_tipo_espaco_';

    const isGroupedOptionValue = (value) => typeof value === 'string' && value.startsWith(GROUP_PREFIX);

    const getRegraFluxoAplicavel = useCallback((origemNodeId) => {
      if (!origemNodeId || !Array.isArray(regras) || !regras.length) {
        return null;
      }

      const regra = [...regras]
        .filter((item) => item?.ativo)
        .sort((a, b) => Number(a?.prioridade || 9999) - Number(b?.prioridade || 9999))
        .find((item) => {
          const origens = Array.isArray(item?.origem_nodes) ? item.origem_nodes : [];
          return origens.includes(origemNodeId);
        });

      return regra || null;
    }, [regras]);

    const mergeRouteSegments = (segmentos = []) => {
      const validos = segmentos.filter(Boolean);
      if (!validos.length) return null;

      let pathFinal = [];
      let distanceFinal = 0;
      const attempted = [];

      validos.forEach((segmento, index) => {
        const path = Array.isArray(segmento.path) ? segmento.path : [];

        if (!path.length) return;

        if (index === 0) {
          pathFinal = [...path];
        } else {
          pathFinal = [...pathFinal, ...path.slice(1)];
        }

        distanceFinal += Number(segmento.distance || 0);

        if (segmento?.meta?.attempted) {
          attempted.push(...segmento.meta.attempted);
        }
      });

      return {
        path: pathFinal,
        distance: distanceFinal,
        meta: {
          strategy: 'business_rule_waypoints',
          attempted,
        },
      };
    };

    const getTipoIdFromGroupedValue = (value) => {
      if (!isGroupedOptionValue(value)) return null;
      const n = Number(String(value).replace(GROUP_PREFIX, ''));
      return Number.isFinite(n) ? n : null;
    };

    const getTipoAgrupado = (tipo) => {
      const raw = tipo?.agrupado;
      if (typeof raw === 'boolean') return raw;

      const s = String(raw ?? '').trim().toLowerCase();
      return s === '1' || s === 'true' || s === 'sim';
    };

    const distanceBetweenNodes = (a, b) => {
      if (!a || !b) return Infinity;
      const dx = Number(a.x) - Number(b.x);
      const dy = Number(a.y) - Number(b.y);
      return Math.sqrt(dx * dx + dy * dy);
    };

    const nodesById = useMemo(() => {
      const map = new Map();
      (nodes || []).forEach((n) => map.set(n.id, n));
      return map;
    }, [nodes]);

    const forceMapRefresh = useCallback((delay = 120) => {
      setTimeout(() => {
        if (mapRef.current) {
          mapRef.current.invalidateSize();
        }
      }, delay);
    }, []);

    const getNodeCirculacao = (node) => {
      if (!node) return null;

      // 1) se vier no próprio node, usa
      if (node.circulacao) {
        return normalizarCirculacao(node.circulacao);
      }

      // 2) tenta inferir pelo tipo de espaço (destinos)
      const tipoId = Number(node?.tipo_espaco_id);
      if (Number.isFinite(tipoId)) {
        const tipo = tiposEspacoMap.get(tipoId);
        const circulacaoTipo = tipo?.circulacao || tipo?.circulacao_tipo; // ajuste conforme teu backend
        if (circulacaoTipo) return normalizarCirculacao(circulacaoTipo);
      }

      return null;
    };

    const getNodePermiteCirculacao = useCallback((node) => {
      if (!node) return false;

      if (node.type === 'intersection') return true;

      if (typeof node.permite_circulacao === 'boolean') {
        return node.permite_circulacao;
      }

      const tipoId = Number(node?.tipo_espaco_id);
      if (!Number.isFinite(tipoId)) return false;

      const tipo = tiposEspacoMap.get(tipoId);
      const valor = tipo?.permite_circulacao;

      if (typeof valor === 'boolean') return valor;

      const raw = String(valor ?? '').trim().toLowerCase();
      return raw === '1' || raw === 'true' || raw === 'sim';
    }, [tiposEspacoMap]);

    const getSharedPrefixLength = (pathA = [], pathB = []) => {
      const limite = Math.min(pathA.length, pathB.length);
      let i = 0;

      while (i < limite && pathA[i]?.id === pathB[i]?.id) {
        i++;
      }

      return i;
    };

    const isNodeAgrupadoByTipo = useCallback((nodeOrId) => {
      if (!nodeOrId) return false;

      const node =
        typeof nodeOrId === 'object'
          ? nodeOrId
          : nodesById.get(nodeOrId);

      if (!node) return false;

      const tipoId = Number(node?.tipo_espaco_id);
      if (!Number.isFinite(tipoId)) return false;

      const tipo = tiposEspacoMap.get(tipoId);
      return getTipoAgrupado(tipo);
    }, [nodesById, tiposEspacoMap]);

    const isDestinoForaDoCircuito = useCallback((
      origem,
      destinoResolvido,
      waypoints = [],
      destinoMetaParam = null
    ) => {
      if (!origem || !destinoResolvido || !waypoints?.length) return false;

      const destinoNodeBase =
        destinoMetaParam && typeof destinoMetaParam === 'object'
          ? destinoMetaParam
          : nodesById.get(destinoResolvido);

      const tipoId = Number(destinoNodeBase?.tipo_espaco_id);
      const tipo = Number.isFinite(tipoId) ? tiposEspacoMap.get(tipoId) : null;
      const destinoEhAgrupado = getTipoAgrupado(tipo);

      if (!destinoEhAgrupado) {
        return false;
      }

      const rotaDireta = findShortestPathWithContext(nodes, edges, origem, destinoResolvido, {
        mode: 'auto',
        allowFallback: true,
        getNodeCirculacao,
        getNodePermiteCirculacao,
        destinationBlockPenalty: 10000,
      });

      if (!rotaDireta?.path?.length) {
        return false;
      }

      const waypointIdsNaRotaDireta = waypoints.filter((id) =>
        rotaDireta.path.some((node) => node?.id === id)
      );

      const algumWaypointNaRotaDireta = waypointIdsNaRotaDireta.length > 0;

      return !algumWaypointNaRotaDireta;
    }, [
      nodes,
      edges,
      nodesById,
      tiposEspacoMap,
      getNodeCirculacao,
      getNodePermiteCirculacao
    ]);

    const isPrefixPath = (smallerPath = [], biggerPath = []) => {
      if (!Array.isArray(smallerPath) || !Array.isArray(biggerPath)) return false;
      if (!smallerPath.length || smallerPath.length > biggerPath.length) return false;

      for (let i = 0; i < smallerPath.length; i++) {
        if (smallerPath[i]?.id !== biggerPath[i]?.id) {
          return false;
        }
      }

      return true;
    };

  const destinationComesBeforeWaypoint = (rotaDiretaDestino, rotaAteWaypoint, destino) => {
    const pathDestino = Array.isArray(rotaDiretaDestino?.path) ? rotaDiretaDestino.path : [];
    const pathWaypoint = Array.isArray(rotaAteWaypoint?.path) ? rotaAteWaypoint.path : [];

    if (!pathDestino.length || !pathWaypoint.length) return false;

    if (pathWaypoint.some((node) => node?.id === destino)) {
      return true;
    }

    if (isPrefixPath(pathDestino, pathWaypoint)) {
      return true;
    }

    if (pathDestino.length > 1) {
      const pathDestinoSemUltimo = pathDestino.slice(0, -1);
      if (isPrefixPath(pathDestinoSemUltimo, pathWaypoint)) {
        return true;
      }
    }

    return false;
  };

  const calcularRotaComWaypoints = useCallback((origem, destino, waypointIds = [], options = {}) => {
  const { destinoMeta = null } = options;
    if (!origem || !destino) return null;

    const waypointsNormalizados = (waypointIds || [])
      .filter(Boolean)
      .filter((id) => id !== origem)
      .filter((id) => id !== destino);

    const segmentos = [];
    let pontoAtual = origem;

    for (let i = 0; i < waypointsNormalizados.length; i++) {
      const waypointId = waypointsNormalizados[i];

      if (!waypointId || pontoAtual === destino) {
        break;
      }

      const rotaAteWaypoint = findShortestPathWithContext(nodes, edges, pontoAtual, waypointId, {
        mode: 'auto',
        allowFallback: true,
        getNodeCirculacao,
        getNodePermiteCirculacao,
        destinationBlockPenalty: 10000,
      });

      if (!rotaAteWaypoint?.path?.length) {
        return null;
      }

      const rotaDiretaDestino = findShortestPathWithContext(nodes, edges, pontoAtual, destino, {
        mode: 'auto',
        allowFallback: true,
        getNodeCirculacao,
        getNodePermiteCirculacao,
        destinationBlockPenalty: 10000,
      });

      if (!rotaDiretaDestino?.path?.length) {
        return null;
      }

      const destinoAntesDoWaypoint = destinationComesBeforeWaypoint(
        rotaDiretaDestino,
        rotaAteWaypoint,
        destino
      );

      const destinoEhAgrupado = isNodeAgrupadoByTipo(destinoMeta || destino);

      const waypointEstaNaRotaDireta = rotaDiretaDestino.path.some(
        (node) => node?.id === waypointId
      );

      if (destinoAntesDoWaypoint) {
        segmentos.push(rotaDiretaDestino);
        return mergeRouteSegments(segmentos);
      }

      if (destinoEhAgrupado && !waypointEstaNaRotaDireta) {
        segmentos.push(rotaDiretaDestino);
        return mergeRouteSegments(segmentos);
      }

      segmentos.push(rotaAteWaypoint);
      pontoAtual = waypointId;
    }

    if (pontoAtual !== destino) {
      const rotaFinal = findShortestPathWithContext(nodes, edges, pontoAtual, destino, {
        mode: 'auto',
        allowFallback: true,
        getNodeCirculacao,
        getNodePermiteCirculacao,
        destinationBlockPenalty: 10000,
      });

      if (!rotaFinal?.path?.length) {
        return null;
      }

      segmentos.push(rotaFinal);
    }

    return mergeRouteSegments(segmentos);
  }, [nodes, edges, getNodeCirculacao, getNodePermiteCirculacao]);

    const handleLimparTudo = () => {
      const estadoReset = {
          pesquisa: '',
          setor: [],
          categoria: [],
          areaInteresse: [],
          tipoEspaco: [],
          expositores: [],
          espacos: []
      };
      
      setFiltrosAtivos(estadoReset);
      handleAplicarFiltros(estadoReset);
    };

    const customSelectStyles = {
      control: (base) => ({
          ...base,
          borderRadius: '12px',
          borderColor: '#dde1e7',
          minHeight: '40px',
          boxShadow: 'none',
          backgroundColor: 'white', 
          '&:hover': { borderColor: corPrincipal }
      }),
      menu: (base) => ({
          ...base,
          zIndex: 9999,         
          backgroundColor: 'white' 
      }),
      menuPortal: (base) => ({ 
          ...base, 
          zIndex: 9999 
      }),
      option: (base, { isSelected, isFocused }) => ({
          ...base,
          backgroundColor: isSelected 
              ? corPrincipal 
              : isFocused 
                  ? '#f8f9fa' 
                  : 'white',
          color: isSelected ? 'white' : '#202124',
          '&:active': { backgroundColor: corPrincipal }
      })
    };

    const resetMapZoom = useCallback(() => {
      if (mapRef.current && mapData?.manifest?.bounds) {
        const { minX, minY, maxX, maxY } = mapData.manifest.bounds;
        const southWest = L.latLng(-maxY, minX);
        const northEast = L.latLng(-minY, maxX);
        const boundsObj = L.latLngBounds(southWest, northEast);

        mapRef.current.fitBounds(boundsObj, { 
            padding: [10, 10], 
            animate: true 
        });
      }
    }, [mapData, mapRef]);

    const handleFiltroDireto = useCallback((selecionado, campo) => {
      if (campo === 'pesquisa') {
        if (searchTimerRef.current) clearTimeout(searchTimerRef.current);

        searchTimerRef.current = setTimeout(() => {
          setFiltrosAtivos(prev => ({ ...prev, pesquisa: selecionado }));
          
          if (!rotaCalculada?.path?.length) {
            setZoomTrigger(prev => prev + 1);
          }

          forceMapRefresh(180);
        }, 400);
      } else {
        const valor = selecionado ? [selecionado.value] : [];
        setFiltrosAtivos(prev => ({ ...prev, [campo]: valor }));
        

        if (!rotaCalculada?.path?.length) {
          setZoomTrigger(prev => prev + 1);
        }

        forceMapRefresh(120);
      }
    }, [forceMapRefresh]);

    const hasRotaAtiva = !!(rotaCalculada?.path?.length && rotaCalculada.path.length > 1);

    const rotaPositions = rotaCalculada?.path
      ? rotaCalculada.path.map((node) => [-node.y, node.x])
      : [];

    const sortedExpositores = useMemo(() => {
      if (!expositores) return [];
      return [...expositores]
      .sort((a, b) =>
        (a.nome_mapa || '').localeCompare(b.nome_mapa || '')
      );
    }, [expositores]);
    
    const toastDisparado = useRef(false);

    useEffect(() => {
      document.body.style.overflow = 'hidden';
      document.body.style.height = '100%';

      return () => {
        document.body.style.overflow = 'auto';
        document.body.style.height = 'auto';
      };
    }, []);

    const calcularRotaContextual = useCallback((origem, destino, options = {}) => {
      const {
        origemSelecionadaOriginal = null,
        destinoSelecionadoOriginal = null,
        origemMeta = null,
        destinoMeta = null,
      } = options;

      if (!origem || !destino) return null;

      const regra = getRegraFluxoAplicavel(origem);

      if (regra) {
        const waypointsOrdenados = Array.isArray(regra?.waypoint_nodes)
          ? [...regra.waypoint_nodes]
              .sort((a, b) => Number(a?.ordem || 9999) - Number(b?.ordem || 9999))
              .map((item) => item?.node_id)
              .filter(Boolean)
          : [];

        if (waypointsOrdenados.length) {
          const resultadoComRegra = calcularRotaComWaypoints(origem, destino, waypointsOrdenados, {
            destinoMeta,
            origemMeta,
            origemSelecionadaOriginal,
            destinoSelecionadoOriginal,
          });

          if (resultadoComRegra?.path?.length > 1) {
            return {
              ...resultadoComRegra,
              meta: {
                ...(resultadoComRegra.meta || {}),
                regraFluxoAplicada: regra.id,
                regraFluxoNome: regra.nome,
                waypointNodes: waypointsOrdenados,
              },
            };
          }

          toast.warning(`A regra "${regra.nome}" não pôde ser aplicada. Exibindo a melhor rota disponível.`);
        }
      }

      const resultado = findShortestPathWithContext(nodes, edges, origem, destino, {
        mode: 'auto',
        allowFallback: true,
        getNodeCirculacao,
        getNodePermiteCirculacao,
        destinationBlockPenalty: 10000,
      });

      if (resultado?.meta?.strategy === 'auto_fallback_flexivel') {
        toast.info('Não foi possível manter uma rota totalmente interna. Exibindo a melhor rota disponível.');
      }

      return resultado;
    }, [
      nodes,
      edges,
      getNodeCirculacao,
      getNodePermiteCirculacao,
      getRegraFluxoAplicavel,
      calcularRotaComWaypoints,
    ]);

    useEffect(() => {
      const urlOrigem = searchParams.get('origem');
      const urlDestino = searchParams.get('destino');
  
      if (urlOrigem && urlDestino && nodes?.length > 0 && edges?.length > 0) {
        if (toastDisparado.current) return;
  
        const origemExiste = nodes.some(n => n.id === urlOrigem);
        const destinoExiste = nodes.some(n => n.id === urlDestino);
  
        if (origemExiste && destinoExiste) {
          toastDisparado.current = true;
  
          const timer = setTimeout(() => {
              setOrigemId(urlOrigem);
              setDestinoId(urlDestino);
              
              const resultado = 
calcularRotaContextual(urlOrigem, urlDestino, {
        origemSelecionadaOriginal: urlOrigem,
        destinoSelecionadoOriginal: urlDestino,
      });

              setRotaCalculada(resultado);
              
              if (resultado) {
                setInstrucoes(generateDirections(resultado.path));
                setIsRoutePanelOpen(true);
                toast.success("Rota carregada a partir do link!", {
                  toastId: "rota-carregada"
                });
              }
          }, 500);
  
          return () => clearTimeout(timer);
        } else {
          if (!toast.isActive("erro-rota")) {
              toast.error("A rota contém pontos inválidos.", { toastId: "erro-rota" });
          }
        }
      }
    }, [nodes, edges, searchParams]);

    useEffect(() => {
      if (!feira?.id) return;

      const isMobile = window.innerWidth <= 960;
      if (!isMobile) return;

      const key = `rota_feira_sidebar_opened_${feira.id}`;
      const jaAbriu = localStorage.getItem(key);

      if (!jaAbriu) {
        const t = setTimeout(() => {
          setIsSidebarOpen(true);
          localStorage.setItem(key, '1');
        }, 350);

        return () => clearTimeout(t);
      }
    }, [feira?.id]);

    const corPrincipal = feira?.configuracao?.[0]?.cor_principal || '#13ade9';
    const corSecundaria = feira?.configuracao?.[0]?.cor_secundaria || '#13ade9';
    const destinosDisponiveis = useMemo(() => {
        return nodes ? nodes.filter(n => n.type === 'destination').sort((a,b) => a.name.localeCompare(b.name)) : [];
    }, [nodes]);

    const contatoComercial = feira?.whatsapp
      ? [{ nome: feira?.nome, whatsapp_principal: feira.whatsapp }]
      : [];
    
    const normalizarCirculacao = (v) => {
      const s = String(v || '').toLowerCase().trim();
      if (s === 'externo') return 'externo';
      if (s === 'transicao') return 'transicao';
      return 'interno'; 
    };

    const destinosOptions = useMemo(() => {
      const options = [];
      const groupedTipoIdsAdded = new Set();

      for (const n of (destinosDisponiveis || [])) {
        if (!n?.name) continue;

        const tipoId = Number(n?.tipo_espaco_id);
        const tipo = Number.isFinite(tipoId) ? tiposEspacoMap.get(tipoId) : null;
        const isAgrupado = getTipoAgrupado(tipo);
        
        if (isAgrupado && tipo) {
          if (groupedTipoIdsAdded.has(tipoId)) continue;

          groupedTipoIdsAdded.add(tipoId);

          options.push({
            value: `${GROUP_PREFIX}${tipoId}`,
            label: (tipo.tipo_espaco ? tipo.tipo_espaco.nome : n.name), // ex.: "Banheiro"
            isGrouped: true,
            tipoEspacoId: tipoId,
          });

          continue;
        }

        // opção normal (node individual)
        options.push({
          value: n.id,
          label: n.name,
          isGrouped: false,
          tipoEspacoId: Number.isFinite(tipoId) ? tipoId : null,
        });
      }

      return options.sort((a, b) => String(a.label).localeCompare(String(b.label)));
    }, [destinosDisponiveis, tiposEspacoMap]);

    const resolveRouteEndpointNodeId = useCallback((selectedValue, otherSelectedValue = null) => {
      if (!selectedValue) return '';

      if (!isGroupedOptionValue(selectedValue)) {
        return selectedValue;
      }

      const tipoId = getTipoIdFromGroupedValue(selectedValue);
      if (!Number.isFinite(tipoId)) return '';

      const candidates = (nodes || [])
        .filter((n) => n?.type === 'destination')
        .filter((n) => Number(n?.tipo_espaco_id) === tipoId);

      if (!candidates.length) return '';

      const otherIsGrouped = isGroupedOptionValue(otherSelectedValue);
      const otherNode = otherSelectedValue && !otherIsGrouped
        ? nodesById.get(otherSelectedValue)
        : null;

      if (otherNode) {
        const sorted = [...candidates].sort(
          (a, b) => distanceBetweenNodes(a, otherNode) - distanceBetweenNodes(b, otherNode)
        );
        return sorted[0]?.id || '';
      }

      const sortedByName = [...candidates].sort((a, b) =>
        String(a?.name || '').localeCompare(String(b?.name || ''))
      );

      return sortedByName[0]?.id || '';
    }, [nodes, nodesById]);

    const handleExpositorClick = useCallback((expositor, standFromClick = null) => {
      if (!expositor) return;

      const standToHighlight = standFromClick || estandesCadastrados?.find(
        (est) => est.expositor_id === expositor.id
      );

      if (standToHighlight) {
        setEstandeDestacado(standToHighlight);
        
        if (destacarEstandeRef.current) {
          destacarEstandeRef.current(standToHighlight);
        }
        
        if (isMobileUI) {
          setIsSidebarOpen(false);
        }
      }
    }, [estandesCadastrados, isMobileUI]);

    const handleAplicarFiltros = (filtros) => {
      setEstandeDestacado(null);

      const filtrosNormalizados = {
        pesquisa: filtros?.pesquisa || '',
        setor: filtros?.setor ||  EMPTY_ARRAY ,
        categoria: filtros?.categoria ||  EMPTY_ARRAY ,
        areaInteresse: filtros?.areaInteresse || EMPTY_ARRAY ,
        tipoEspaco: filtros?.tipoEspaco || EMPTY_ARRAY ,
        expositores: filtros?.expositores ||  EMPTY_ARRAY ,
        espacos: filtros?.espacos ||  EMPTY_ARRAY ,
      };

      setFiltrosAtivos(filtrosNormalizados);
      
      if (!rotaCalculada?.path?.length) {
        setZoomTrigger(prev => prev + 1);
      }

      // fecha modal (se aplicável) e redesenha mapa
      setFilterModalOpen(false);
      forceMapRefresh(220);
    };

    const handleRefreshPagina = useCallback(() => {
      window.location.reload();
    }, []);

    const toggleSidebar = useCallback(() => {
        setIsSidebarOpen(prev => !prev);
    }, []);

    const updateHighlightFromRouteSelection = useCallback((selectedValue, side) => {
      if (!selectedValue) {
        if (side === 'origem') setEstandeDestacadoOrigem(null);
        if (side === 'destino') setEstandeDestacadoDestino(null);
        return;
      }

      if (typeof selectedValue === 'string' && selectedValue.startsWith(GROUP_PREFIX)) {
        if (side === 'origem') setEstandeDestacadoOrigem(null);
        if (side === 'destino') setEstandeDestacadoDestino(null);
        return;
      }

      if (typeof selectedValue === 'string' && selectedValue.startsWith('dest_')) {
        const hash = selectedValue.replace('dest_', '');
        const stand = (estandesCadastrados || []).find(e => String(e.hash_path) === String(hash));
        if (stand) {
          if (side === 'origem') setEstandeDestacadoOrigem(stand);
          if (side === 'destino') setEstandeDestacadoDestino(stand);
          return;
        }
      }

      if (side === 'origem') setEstandeDestacadoOrigem(null);
      if (side === 'destino') setEstandeDestacadoDestino(null);
    }, [estandesCadastrados]);

    const renderRedesSociais = () => {
        const { facebook, instagram, youtube, linkedin, twitter, tiktok } = feira || {};
        const redes = [];
        if (facebook) redes.push({ icon: "bx bxl-facebook-circle", url: facebook });
        if (instagram) redes.push({ icon: "bx bxl-instagram", url: instagram });
        if (youtube) redes.push({ icon: "bx bxl-youtube", url: youtube });
        if (linkedin) redes.push({ icon: "bx bxl-linkedin-square", url: linkedin });
        if (twitter) redes.push({ icon: "bx bxl-twitter", url: twitter });
        if (tiktok) redes.push({ icon: "bx bxl-tiktok", url: tiktok });

        if (redes.length === 0) return null;

        return (
        <div className="fair-social">
            {redes.map((rede, index) => (
            <a key={index} href={rede.url} target="_blank" rel="noreferrer">
                <i className={rede.icon} style={{color: "white", fontSize: "24px", margin: "0 8px"}}></i>
            </a>
            ))}
        </div>
        );
    };
      
    const abrirGoogleMaps = () => {
        if (!feira) return;
        const enderecoCompleto = `${feira.rua}, ${feira.numero} - ${feira.bairro}, ${feira.cidade} - ${feira.estado}, ${feira.cep}`;
        const enderecoCodificado = encodeURIComponent(enderecoCompleto);
        window.open(`https://www.google.com/maps/search/?api=1&query=${enderecoCodificado}`);
    };

    const abrirContato = () => {
      if (!feira) return;
      setExibirModalContato(true);
    };
    
    const adicionarPontoRota = useCallback((nodeOrObject, preferSlot = 'auto') => {
      const nodeObj = nodeOrObject && typeof nodeOrObject === 'object' ? nodeOrObject : null;
      const nodeId = nodeObj?.id || nodeOrObject;

      if (!nodeId) return;
      
      const origemAtual = origemIdRef.current;
      const destinoAtual = destinoIdRef.current;

      const hasOrigem = !!origemAtual;
      const hasDestino = !!destinoAtual;

      const escolherSlot = () => {
        if (preferSlot === 'origem' || preferSlot === 'destino') return preferSlot;

        if (hasOrigem && !hasDestino) return 'destino';
        if (hasDestino && !hasOrigem) return 'origem';
        if (!hasOrigem && !hasDestino) return 'origem';
        return 'destino';
      };

      const slot = escolherSlot();
      const other = slot === 'origem' ? destinoAtual : origemAtual;

      if (other && other === nodeId) {
        toast.warn("Origem e destino não podem ser o mesmo ponto.");
        return;
      }

      const recalcular = (o, d) => {
        const origemResolvida = resolveRouteEndpointNodeId(o, d);
        const destinoResolvido = resolveRouteEndpointNodeId(d, o);

        if (!origemResolvida || !destinoResolvido || origemResolvida === destinoResolvido) {
          setRotaCalculada(null);
          setInstrucoes([]);
          return;
        }

        const origemNode =
          typeof o === 'object'
            ? o
            : (nodesById.get(origemResolvida) || nodesById.get(o) || null);

        const destinoNode =
          typeof d === 'object'
            ? d
            : (isGroupedOptionValue(d)
                ? (nodesById.get(destinoResolvido) || null)
                : (nodesById.get(d) || nodesById.get(destinoResolvido) || null));

        const resultado = calcularRotaContextual(origemResolvida, destinoResolvido, {
          origemSelecionadaOriginal: typeof o === 'object' ? o?.id : o,
          destinoSelecionadoOriginal: typeof d === 'object' ? d?.id : d,
          origemMeta: origemNode,
          destinoMeta: destinoNode,
        });

        setRotaCalculada(resultado);
        setInstrucoes(resultado?.path ? generateDirections(resultado.path) : []);
      };

      if (slot === 'origem') {
        setOrigemId(nodeId);
        setOrigemMeta(nodeObj || nodesById.get(nodeId) || null);
        toast.info(hasDestino ? "Origem definida" : "Origem definida");

        if (destinoAtual) recalcular(nodeId, destinoAtual);
        return;
      }

      setDestinoId(nodeId);
      setDestinoMeta(nodeObj || nodesById.get(nodeId) || null);

      if (!hasDestino) toast.info("Destino definido");
      else toast.info("Destino atualizado");

      if (origemAtual) recalcular(origemAtual, nodeId);
    }, [nodesById, calcularRotaContextual, resolveRouteEndpointNodeId, isGroupedOptionValue]);

    const handleCriarRota = (expositor) => {
      
      const estande = estandesCadastrados?.find(e => e.expositor_id === expositor.id);
      
      if (!estande) {
        clearSelectedExpositor();
        return;
      }

      const hash = 'dest_' + estande.hash_path;

      let prefer = 'auto';
      if (origemId && !destinoId) prefer = 'destino';
      else if (destinoId && !origemId) prefer = 'origem';
      else if (origemId && destinoId) prefer = 'destino';
      else prefer = 'origem';

      updateHighlightFromRouteSelection(hash, prefer);
      adicionarPontoRota(hash, prefer);
      setIsPanelOpen(true);
      clearSelectedExpositor();
    };

    const handleSelectionFromMap = useCallback((nodeOrId) => {
      adicionarPontoRota(nodeOrId, 'auto');
      setIsPanelOpen(true);
    }, [adicionarPontoRota]);

    const handleInverterRota = () => {
  if (!origemId || !destinoId) {
    toast.warn("Selecione origem e destino para inverter.");
    return;
  }

  const novaOrigem = destinoId;
  const novoDestino = origemId;

  const origemResolvida = resolveRouteEndpointNodeId(novaOrigem, novoDestino);
  const destinoResolvido = resolveRouteEndpointNodeId(novoDestino, novaOrigem);

  const resultado = calcularRotaContextual(origemResolvida, destinoResolvido, {
    origemSelecionadaOriginal: novaOrigem,
    destinoSelecionadoOriginal: novoDestino,
    origemMeta: destinoMeta || nodesById.get(origemResolvida) || null,
    destinoMeta: origemMeta || nodesById.get(destinoResolvido) || null,
  });

  setOrigemId(novaOrigem);
  setDestinoId(novoDestino);

  setOrigemMeta(destinoMeta || nodesById.get(origemResolvida) || nodesById.get(novaOrigem) || null);
  setDestinoMeta(origemMeta || nodesById.get(destinoResolvido) || nodesById.get(novoDestino) || null);

  setRotaCalculada(resultado);

  if (resultado) {
    setInstrucoes(generateDirections(resultado.path));
    toast.success("Rota invertida com sucesso!");
  } else {
    setInstrucoes([]);
    toast.error("Não foi possível recalcular a rota invertida.");
  }
};

    const SidebarBackdrop = () => (
        <div 
            className={`sidebar-backdrop ${isSidebarOpen ? 'is-visible' : ''}`} 
            onClick={toggleSidebar}
        />
    );

    const SidebarBody = () => (
        <div className="sidebar-body">
            <div className="rota-sidebar-tabs">
                <button 
                    className={`rota-sidebar-tab ${activeTab === 'sobre' ? 'is-active' : ''}`} 
                    onClick={() => setActiveTab('sobre')}
                >
                    Sobre
                </button>
                <button 
                    className={`rota-sidebar-tab ${activeTab === 'expositores' ? 'is-active' : ''}`} 
                    onClick={() => setActiveTab('expositores')}
                >
                    Expositores
                </button>
            </div>

            <div className="tab-panels">
                <div className={`tab-panel ${activeTab === 'sobre' ? 'is-active' : ''}`} id="tab-sobre">
                    <h1 className="event-title">Sobre {feira.nome}</h1>
            
                    <p className="event-text">
                        {feira.descricao}
                    </p>
            
                    <div className="btn-group">
                        <button className="btn-primary" onClick={abrirGoogleMaps}>Como Chegar</button>
                        <button className="btn-secondary"  onClick={abrirContato}>Contato</button>
                    </div>
                </div>

                <div className={`tab-panel ${activeTab === 'expositores' ? 'is-active' : ''}`} id="tab-expositores">
                    <p className="event-text">
                        Selecione um expositor para localizar o estande no mapa e traçar uma rota até ele.
                    </p>
                    <div className="exhibitors-grid">
                    {sortedExpositores.map(exhibitor => (
                      <ExpositorCardMemo 
                          key={exhibitor.id} // Chave estável
                          exhibitor={exhibitor}
                          onCardClick={handleExpositorClick}
                          onTraceRouteClick={handleCriarRota} // Passe a nova função aqui
                      />
                  ))}
                  </div>
                </div>
            </div>

            <CommercialModal 
              isOpen={exibirModalContato}
              onClose={() => setExibirModalContato(false)}
              contacts={contatoComercial}
              nomeFeira={feira?.nome || ""}
              corPrincipal={corPrincipal || "#25D366"}
            />
            
        </div>
    );

    const handleCalcularRota = () => {
      if (!origemId || !destinoId) {
        toast.warn("Por favor, selecione um ponto de origem e um de destino.");
        return;
      }

  const origemResolvida = resolveRouteEndpointNodeId(origemId, destinoId);
  const destinoResolvido = resolveRouteEndpointNodeId(destinoId, origemId);

  if (!origemResolvida || !destinoResolvido) {
    toast.error("Não foi possível resolver um dos pontos selecionados.");
    return;
  }

  if (origemResolvida === destinoResolvido) {
    setRotaCalculada(null);
    setInstrucoes([]);
    toast.warn("Origem e destino resultaram no mesmo ponto.");
    return;
  }

  const origemMetaCalculada =
    origemMeta ||
    (!isGroupedOptionValue(origemId)
      ? (nodesById.get(origemResolvida) || nodesById.get(origemId) || null)
      : null);

  const destinoMetaCalculada =
    destinoMeta ||
    (isGroupedOptionValue(destinoId)
      ? (nodesById.get(destinoResolvido) || null)
      : (nodesById.get(destinoId) || nodesById.get(destinoResolvido) || null));

  const resultado = calcularRotaContextual(origemResolvida, destinoResolvido, {
    origemSelecionadaOriginal: origemId,
    destinoSelecionadoOriginal: destinoId,
    origemMeta: origemMetaCalculada,
    destinoMeta: destinoMetaCalculada,
  });

  setRotaCalculada(resultado);

  if (resultado?.path?.length > 1) {
    trackEvent("route_calculated", {
      feira_id: feira.id,
      origem_id: origemResolvida,
      destino_id: destinoResolvido,
      path_len: resultado.path.length,
    });
    setRouteZoomTrigger(prev => prev + 1);
  } else {
    trackEvent("route_failed", {
      feira_id: feira.id,
      origem_id: origemResolvida || "",
      destino_id: destinoResolvido || "",
      reason: "no_path",
    });
  }

  if (isMobileUI) {
    setSheetState('collapsed');
  }

  if (resultado) {
    setExibirInstrucoesMobile(true);

    if (rotaComCaminho) setInstrucoes(generateDirections(resultado.path));
    toast.success("Rota encontrada!");
  } else {
    setInstrucoes([]);
    toast.error("Não foi possível encontrar um caminho.");
  }
};

    const fecharModalRota = useCallback(() => {
      setIsRoutePanelOpen(false); 
      setExibirInstrucoesMobile(false);
  
    }, []);

    const handleLimparRota = () => {
      setOrigemId('');
      setDestinoId('');
      setOrigemMeta(null);
      setDestinoMeta(null);
      setRotaCalculada(null);
      setInstrucoes([]);
      setEstandeDestacadoDestino(null);
      setEstandeDestacadoOrigem(null);
      setEstandeDestacado(null);
      setHighlightedNodeId(null);
      resetMapZoom();
    };
    
    const handleOrigemChange = (selectedOption) => {
      const value = selectedOption ? selectedOption.value : '';
      setOrigemId(value);
      setOrigemMeta(value ? (nodesById.get(value) || null) : null);
      updateHighlightFromRouteSelection(value, 'origem');

      if (!value) {
        setRotaCalculada(null);
        setInstrucoes([]);
        setHighlightedNodeId(null);
        setRouteZoomTrigger(0);
      }
    };

    const handleDestinoChange = (selectedOption) => {
      const value = selectedOption ? selectedOption.value : '';
      setDestinoId(value);
      setDestinoMeta(value ? (nodesById.get(value) || null) : null);
      updateHighlightFromRouteSelection(value, 'destino');

      if (!value) {
        setRotaCalculada(null);
        setInstrucoes([]);
        setHighlightedNodeId(null);
        setRouteZoomTrigger(0);
      }
    };

    const getOptionByValue = useCallback((value) => {
      if (!value) return null;

      const option = destinosOptions.find((o) => o.value === value);
      if (option) return option;

      const node = (nodes || []).find((n) => n.id === value);
      if (!node) return null;

      return {
        value: node.id,
        label: node.name,
        isGrouped: false,
        tipoEspacoId: Number.isFinite(Number(node?.tipo_espaco_id))
          ? Number(node.tipo_espaco_id)
          : null,
      };
    }, [destinosOptions, nodes]);

    
    const filteredEstandesIds = useMemo(() => {
        const temFiltroAtivo = 
            (filtrosAtivos.pesquisa && filtrosAtivos.pesquisa.length > 0) ||
            (filtrosAtivos.setor && filtrosAtivos.setor.length > 0) ||
            (filtrosAtivos.categoria && filtrosAtivos.categoria.length > 0) ||
            (filtrosAtivos.areaInteresse && filtrosAtivos.areaInteresse.length > 0) ||
            (filtrosAtivos.tipoEspaco && filtrosAtivos.tipoEspaco.length > 0) ||
            (filtrosAtivos.expositores && filtrosAtivos.expositores.length > 0) ||
            (filtrosAtivos.espacos && filtrosAtivos.espacos.length > 0);

        if (!temFiltroAtivo || !estandesCadastrados) return null; 

        return estandesCadastrados.filter(estande => {
            const expositor = estande.expositor ? estande.expositor : null;

            if (filtrosAtivos.expositores?.length > 0) {
              if (!expositor) return false;
              if (!filtrosAtivos.expositores.includes(expositor.id)) return false;
            }

            if (filtrosAtivos.espacos?.length > 0) {
              if (!estande) return false;
              if (!filtrosAtivos.espacos.includes(estande.id)) return false;
            }

            if (filtrosAtivos.tipoEspaco?.length > 0) {
                if (!filtrosAtivos.tipoEspaco.includes(estande.tipo_espaco_id)) return false;
            }

            if (filtrosAtivos.setor?.length > 0) {
                if (!expositor) return false;
                const setoresExpositor = (expositor.setor || []).map(s => s.id || s);
                const temSetor = filtrosAtivos.setor.some(idFiltro => setoresExpositor.includes(idFiltro));
                if (!temSetor) return false;
            }

            if (filtrosAtivos.categoria?.length > 0) {
                if (!expositor) return false;
                const categoriasExpositor = (expositor.categoria || []).map(c => c.id || c);
                const temCategoria = filtrosAtivos.categoria.some(idFiltro => categoriasExpositor.includes(idFiltro));
                if (!temCategoria) return false;
            }
            return true;
        }).map(e => e.id); 
    }, [estandesCadastrados, filtrosAtivos]);

    const posicaoBanner = feira?.configuracao_rota?.[0]?.local_banner === 1 ? "topo" : "rodape";
    const cfgRota = feira?.configuracao_rota?.[0] || {};
    const mapaCentralizado = !!cfgRota.mapa_centralizado;
    const rotaComCaminho = !!cfgRota.abrir_caminho_rota_texto;
    const bannerDestaque = !!cfgRota.tem_banner_destaque === true;
    const corPlanoFundo = cfgRota.cor_plano_fundo || '#rgba(255, 255, 255, 1)';

    const mapConfig = useMemo(() => ({
      cor_principal: feira?.configuracao_rota?.[0]?.cor_principal
        || feira?.configuracao?.[0]?.cor_secundaria
        || '#8f4de9',
      cor_estande_destacado: feira?.configuracao_rota?.[0]?.cor_estande_destacado || '#FFD700',
      cor_estande_padrao: feira?.configuracao_rota?.[0]?.cor_estande_padrao,
      cor_label: feira?.configuracao_rota?.[0]?.cor_label || '#000000',
      cor_traco_rota: feira?.configuracao_rota?.[0]?.cor_traco_rota || "rgba(11, 195, 97, 1)",
      cor_plano_fundo: cfgRota.cor_plano_fundo || '#ffffffff',
      cor_contorno_estande: cfgRota.cor_contorno_estandes || '#272626ff',
    }), [
      feira?.configuracao_rota,
      feira?.configuracao,
      cfgRota.cor_plano_fundo,
      cfgRota.cor_contorno_estandes,
    ]);
    
    useEffect(() => {
      if (!origemId || !destinoId) {
        setRotaCalculada(null);
        setInstrucoes([]);
      }
    }, [origemId, destinoId]);

    if (isLoading) {
      return (
        <div style={{
          position: 'fixed',
          inset: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: 'transparent',
          zIndex: 9999
          }}>
          <img
              src={loadingGif}
              alt="Carregando..."
              style={{ width: 96, height: 96, imageRendering: 'crisp-edges' }}
          />
        </div>
      );
    }

    if (error) {
        return <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>Erro: {error}</div>;
    }

    if (!feira) {
        return <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>Nenhuma feira encontrada.</div>;
    }

    let configuracaoExpositor = {};
    try {
        if (feira.configuracao_rota && feira.configuracao_rota.length > 0) {
            configuracaoExpositor = JSON.parse(feira.configuracao_rota[0].configuracao_expositor);
        }
    } catch (e) {
        console.error("Erro ao parsear configuracao_expositor:", e);
    }
      
    const shareUrl = rotaCalculada 
      ? `${window.location.origin}${window.location.pathname}?origem=${origemId}&destino=${destinoId}`
      : '';
  
    return (
        <>
          <div className={`modulo-rotas-container ${mapaCentralizado ? 'is-mapa-centralizado' : ''}`} 
            style={{ 
              '--primary-color': corPrincipal, 
              '--corPlanoFundo': corPlanoFundo,
              '--second-color': corSecundaria }}>

            <div className="app-frame">

              <ModalFiltros
                isOpen={isFilterModalOpen}
                toggle={() => setFilterModalOpen(false)}
                estandes={estandesCadastrados}
                tiposEspaco={tiposEspacoFeira} 
                setores={setoresFeira}         
                categorias={categoriasFeira}   
                areasInteresse={areasInteresseFeira} 
                onAplicarFiltros={handleAplicarFiltros}
                expositores={sortedExpositores}
            
              />

              {isMobileUI && isRoutePanelOpen && (
                <RouteTopBarMobile
                  origemId={origemId}
                  destinoId={destinoId}
                  destinosOptions={destinosOptions}
                  getOptionByValue={getOptionByValue}
                  onOrigemChange={handleOrigemChange}
                  onDestinoChange={handleDestinoChange}
                  onInverter={handleInverterRota}
                  onCalcularRota={handleCalcularRota}
                  onFecharRota={fecharModalRota}
                />
              )}

              {isMobileUI && rotaCalculada && exibirInstrucoesMobile && (
                <EncontrarRotaPanel
                  isOpen={true}
                  isMobile={true}
                  sheetState={sheetState}
                  onToggleSheet={toggleSheet}
                  mode="sheet"            
                  onSheetStateChange={setSheetState}
                  onLimparRota={handleLimparRota}
                  onCompartilhar={() => setModalCompartilharVisivel(true)}
                  onFecharRota={fecharModalRota}
                  instrucoes={instrucoes}
                  mostrarCaminhoTexto={rotaComCaminho}
                  getOptionByValue={getOptionByValue}
                />
              )}
          
          {!isMobileUI && (
              <EncontrarRotaPanel
                isOpen={isPanelOpen}
                isMobile={isMobileUI}
                sheetState={sheetState}
                onToggleSheet={toggleSheet}
                origemId={origemId}
                destinoId={destinoId}
                destinosOptions={destinosOptions}
                onOrigemChange={handleOrigemChange}
                onDestinoChange={handleDestinoChange}
                onCalcularRota={handleCalcularRota}
                onLimparRota={handleLimparRota}
                onFecharRota={fecharModalRota}
                onCompartilhar={() => setModalCompartilharVisivel(true)}
                rotaCalculada={rotaCalculada}
                instrucoes={instrucoes}
                onInverter={handleInverterRota}
                mostrarCaminhoTexto={rotaComCaminho}
                mode="full"
                getOptionByValue={getOptionByValue}
              />)}

              <Modal isOpen={modalCompartilharVisivel} toggle={() => setModalCompartilharVisivel(false)} centered>
                <ModalHeader toggle={() => setModalCompartilharVisivel(false)}>Compartilhar Rota</ModalHeader>
                <ModalBody className="text-center">
                  <p>Escaneie o QR Code ou copie o link para abrir esta rota.</p>
                  <div className="p-3 bg-light d-inline-block">
                    <QRCodeSVG value={shareUrl} size={256} />
                  </div>
                  <Input 
                    type="text" 
                    value={shareUrl} 
                    readOnly 
                    className="mt-3" 
                    onClick={(e) => e.target.select()}
                  />
                </ModalBody>
              </Modal>

              <SidebarBackdrop />

              {bannerDestaque && 
                feira.expositor_destaque?.length > 0 && (
                posicaoBanner === 'topo' && (
                  <BannerExpositores 
                    expositores={feira.expositor_destaque} 
                    onLogoClick={handleExpositorClick}
                    posicao="topo"
                    formato="retangulo"
                  />
                )
              )}

              <div className="top-bar">
                  <div className="top-left">
                      <button className="sidebar-toggle" onClick={toggleSidebar}>
                        Ver informações da feira
                      </button>
                  </div>
              </div>

                <div className="layout">
                    <aside className={`sidebar-rotas ${isSidebarOpen ? 'is-open' : ''}`}>
                        <div className="sidebar-header">
                            <div className="fair-logo">
                                <img src={feira.logoUrl} alt="Logomarca feira" className="event-image"/>
                            </div>

                            {renderRedesSociais()}

                            <div className="event-meta">
                                {periodoFormatado && (
                                    <span>{periodoFormatado}</span>
                                )}
                            </div>

                            <div className="event-translate">
                                <TradutorMapa />
                            </div>
                        </div>
                        
                        <SidebarBody />
                    </aside>

                    <main className="map-panel">
                      <div className="map-header">
                        
                        <div className="filter-bar-desktop">
                          <div className="filter-item-grow">
                            {showExpositores && (
                              <div key="expositores" className="filter-item-fixed">
                              <Select
                                name="expositores"
                                value={expositoresOptions.find(o => (filtrosAtivos.expositores || []).includes(o.value)) || null}
                                isClearable
                                onChange={(v) => handleFiltroDireto(v, 'expositores')}
                                options={expositoresOptions}
                                filterOption={filterOptionBySearch}
                                formatOptionLabel={formatOptionLabelTwoLines}
                                components={{ ClearIndicator: ClearIndicatorLimpar }}
                                placeholder="Busque por expositor"
                                styles={customSelectStyles}
                                menuPortalTarget={document.body}
                              />
                              </div>
                            )}
                          </div>

                          {showEstandes && (
                                <div key="espacos" className="filter-item-fixed">
                                <Select
                                  name="espacos"
                                  value={estandesOptions.find(o => (filtrosAtivos.espacos || []).includes(o.value)) || null}
                                  isClearable
                                  onChange={(v) => handleFiltroDireto(v, 'espacos')}
                                  options={estandesOptions}
                                  filterOption={filterOptionBySearch}
                                  formatOptionLabel={formatOptionLabelTwoLines}
                                  components={{ ClearIndicator: ClearIndicatorLimpar }}
                                  placeholder="Espaço"
                                  styles={customSelectStyles}
                                  menuPortalTarget={document.body}
                                />
                                </div>
                          
                              )}
                          {[
                            { p: 'Serviços', n: 'tipoEspaco', opt: tiposEspacoFeira.map(t => t.tipo_espaco) },
                               // opt: [...(tiposEspacoFeira || [])]
                              // .sort((a, b) => String(a?.tipo_espaco.nome || "").localeCompare(String(b?.tipo_espaco.nome || "")))
                              // .map(t => t.tipo_espaco)},
                            { p: 'Setor', n: 'setor', opt: setoresFeira },
                            { p: 'Categoria', n: 'categoria', opt: categoriasFeira },].map((filtro) => (
                              filtro.opt.length > 0 && (
                                <div key={filtro.n} className="filter-item-fixed">
                                  <Select
                                    placeholder={filtro.p}
                                    isClearable
                                    options={formatOptions(filtro.opt)}
                                    styles={customSelectStyles}
                                    menuPortalTarget={document.body}
                                    value={formatOptions(filtro.opt).find(o => filtrosAtivos[filtro.n]?.includes(o.value)) || null}
                                    onChange={(v) => handleFiltroDireto(v, filtro.n)}
                                  />
                                </div>)
                            ))}
    
                          <button 
                            className="btn btn-warning px-3" 
                            title="Limpar todos os filtros"
                            onClick={handleLimparTudo}
                            style={{ borderRadius: '12px', height: '40px' }}
                          >
                            <i className="bx bx-eraser"></i> Limpar Filtros
                          </button>

                        </div>

                        <div className="map-header-actions">
                          <button 
                            className="btn-secondary d-md-none" 
                            type="button" 
                            onClick={() => setFilterModalOpen(true)}
                          >
                            <span>Filtros</span>
                          </button>

                          {hasRotaAtiva ? (
                            <div className="d-flex gap-2">
                              {!exibirInstrucoesMobile && isMobileUI && (
                                <button className="btn btn-primary" onClick={() => setExibirInstrucoesMobile(true)}>
                                  Ver Orientações
                                </button>
                              )}
                              <button className="btn btn-warning" onClick={handleLimparRota}>
                                Limpar Rota
                              </button>
                            </div>
                          ) : (
                            <div className="d-flex align-items-center gap-2">
                              <button
                                className="btn btn-primary"
                                onClick={() => setIsPanelOpen(!isPanelOpen)}
                              >
                                <span>{isPanelOpen ? 'Esconder' : 'Criar Rota'}</span>
                              </button>

                              <button
                                type="button"
                                className="btn btn-success"
                                onClick={handleRefreshPagina}
                                title="Atualizar página"
                                aria-label="Atualizar página"
                                style={{height: 40, padding: 4, borderRadius: 12 }}
                              >
                                <i className="ri-refresh-line" style={{ fontSize: 18, color:"white" }} /><span>{' Atualizar'}</span>
                              </button>
                            </div>
                          )}
                         
                        </div>
                      </div>
                      
                      <div className="map-inner-frame">
                        {feira && mapData && estandesCadastrados && (
                          <MapaFeiraBasico
                            feiraId={feira.id}
                            configuracao={mapConfig}
                            onEstandeClick={(stand) => {
                              if (stand.expositor) {
                                handleExpositorClick(stand.expositor, stand);
                              }
                            }}
                            onPointSelected={handleSelectionFromMap}
                            destacarEstandeRef={destacarEstandeRef}
                            estandesCadastrados={estandesCadastrados}
                            tiposEspacoFeira={tiposEspacoFeira}
                            mapData={mapData}
                            fundoUrl={fundoUrl}
                            imagemFundo={imagemFundo}
                            nodes={nodes}
                            edges={edges}
                            estandeDestacado={estandeDestacado}
                            rotaPositions={rotaPositions}
                            filteredEstandesIds={filteredEstandesIds}
                            externalMapRef={mapRef}
                            origemId={origemId}   
                            destinoId={destinoId}
                            filteredTypesIds={filtrosAtivos.tipoEspaco || EMPTY_ARRAY}
                            pesquisa={filtrosAtivos.pesquisa}
                            zoomTrigger={zoomTrigger}
                            tilesUrl={tilesUrl}
                            handleCriarRota={handleCriarRota}
                            highlightedNodeId={highlightedNodeId}
                            routeZoomTrigger={routeZoomTrigger}
                            estandeDestacadoOrigem={estandeDestacadoOrigem}
                            estandeDestacadoDestino={estandeDestacadoDestino}
                          />
                        )}
                      
                      </div>

                      {posicaoBanner === 'rodape' && (
                        <BannerExpositores 
                          expositores={feira.expositor_destaque} 
                          onLogoClick={handleExpositorClick}
                          posicao="rodape"
                          formato="retangulo"
                        />
                      )}
                        
                      <FooterDev />
                    </main>
                </div>
            </div>
          </div>
        </>
    );
};

export default RotasModulo;